export default __webpack_public_path__ + "static/media/Invite-mensagem-senha.a435016f.png";